<template>
  <b-row>
    <div class="spinner-container" style="margin: auto;">
      <div id="spinner"></div>
      <p class="title-text">{{lang=='en' ? 'Generation in progress ...':'동영상 생성 중 ...'}}{{ percentage !== undefined ? `  ${percentage}%` : '' }}</p>
    </div>
  </b-row>
</template>

<script>
export default {
  name: 'ProcessingPageView',

  props: {
    lang: {
      type: String,
      required: true
    },
    percentage: {
      type: Number,
      required: false,
      default: undefined
    },
  },
}
</script>
